<template>
  <div class="header-container">
    <!-- <i v-if="sessionType === 2" class="el-icon-picture-outline"></i>
    <i v-else class="el-icon-chat-dot-square"></i> -->
    <img src="@/assets/ai/ai.png" height="30px" @click="handleClickImg" />
    <span class="session-name">Hello，我是你的私人选品助手</span>
    <img src="@/assets/ai/little-k.png" height="20px" @click="handleClickImg" class="little-k" />
    <span class="sub-session-name">{{ subSessionName }}</span>
  </div>
</template>

<script>
export default {
  name: "MessageBoxHeader",
  props: {
    sessionId: String,
    sessionName: String,
    sessionType: Number,
    subSessionName: String
  },
  methods: {
    handleClickImg(e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  font-size: 18px;
  display: flex;
  align-items: center;

  .session-name {
    margin-left: 10px;
    margin-right: 5px;
    font-weight: 600;
  }

  .little-k {
    margin-right: 10px;
  }

  .sub-session-name {
    font-size: 14px;
    color: #585858;
  }
}
</style>